export default __webpack_public_path__ + "static/media/Time_Circle.eea90a29.svg";